import { FC } from 'react'

import { useProject } from '@builddocs/data-management'
import { Box, MenuItem, MenuList, Tooltip } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import archiveIcon from '../../../src/assets/archive.svg'
import docstoreIcon from '../../../src/assets/docstore.svg'
import journalsIcon from '../../../src/assets/journals.svg'
import registryIcon from '../../../src/assets/registry.svg'
import requisitesIcon from '../../../src/assets/requisites.svg'
import statisticsIcon from '../../../src/assets/statistics.svg'

type Props = {
  currentProjectId: string
}

const NavLinks: FC<Props> = ({ currentProjectId }) => {
  const location = useLocation()
  const { project } = useProject(currentProjectId)

  type Tab = {
    label: string
    path: string
    icon?: string
  }
  const tabs: Tab[] = [
    {
      label: 'Реквизиты',
      path: `requisites`,
      icon: requisitesIcon,
    },
    {
      label: 'Статистика',
      path: 'statistics',
      icon: statisticsIcon,
    },
    {
      label: 'Документарий',
      path: `contracts/${currentProjectId}/docstore`,
      icon: docstoreIcon,
    },
    {
      label: 'Реестр актов',
      path: 'registry-of-acts',
      icon: registryIcon,
    },
    {
      label: 'Журналы',
      path: `contracts/${currentProjectId}/journals`,
      icon: journalsIcon,
    },
  ]

  const pikTabs: Tab[] = [
    {
      label: 'Архив',
      path: `archive`,
      icon: archiveIcon,
    },
  ]

  return (
    <MenuList>
      {tabs.map(tab => {
        if (tab.label === 'Журналы')
          return (
            <Tooltip title="Данный функционал дорабатывается">
              <MenuItem
                key={tab.label}
                component={RouterLink}
                sx={{
                  gap: 1,
                  marginBottom: 0.5,
                  borderRadius: 1,
                  color: 'rgba(0, 0, 0, 0.6)',
                }}
                to="#"
              >
                <Box component="img" src={tab.icon ? tab.icon : ''} />
                <p>{tab.label}</p>
              </MenuItem>
            </Tooltip>
          )
        return (
          <MenuItem
            key={tab.label}
            component={RouterLink}
            selected={
              location.pathname === `/projects/${currentProjectId}/` + tab.path
            }
            sx={{
              gap: 1,
              marginBottom: 0.5,
              borderRadius: 1,
              color: '#0034AD',
            }}
            to={'/projects/' + currentProjectId + '/' + tab.path}
          >
            <Box component="img" src={tab.icon ? tab.icon : ''} />
            <p>{tab.label}</p>
          </MenuItem>
        )
      })}
      {project?.integrations?.includes('PIK') &&
        pikTabs.map(tab => {
          return (
            <MenuItem
              key={tab.label}
              component={RouterLink}
              selected={
                location.pathname ===
                `/projects/${currentProjectId}/` + tab.path
              }
              sx={{
                gap: 1,
                marginBottom: 0.5,
                borderRadius: 1,
                color: '#0034AD',
              }}
              to={'/projects/' + currentProjectId + '/' + tab.path}
            >
              <Box component="img" src={tab.icon ? tab.icon : ''} />
              <p>{tab.label}</p>
            </MenuItem>
          )
        })}
    </MenuList>
  )
}

export default NavLinks
